// extracted by mini-css-extract-plugin
export var label = "_is-2";
export var slideContainer = "_is-0";
export var slider = "_is-1";